import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useCustomTranslation } from '../helpers/hooks';

import PaymentCard from './PaymentCard';
import Progress from './Progress';
import PaymentInitialization from './PaymentInitialization';
import { availableLanguages } from '../helpers/constants';

const routePathPrepend = `/:lng(${availableLanguages.join('|')})`;

export default function Content({ routes }) {
  const { urlFor } = useCustomTranslation();
  const t = useTranslation();

  const resultRoute = routes.find(({ name }) => name === 'invoiceResult');

  return (
    <PaymentInitialization>
      <Routes>
          <Route
            path={t.i18n.language + resultRoute.path}
            element={<resultRoute.component />}
          />

        <Route
          path="*"
          element={
            <>
              <PaymentCard />
              <Progress />

              <Routes>
                {routes
                  .filter(({ name }) => name !== 'invoiceResult')
                  .map(({ name, path, component: Component }) => {
                    return (
                      <Route
                        key={name}
                        path={t.i18n.language + path}
                        element={<Component />}
                      />
                    );
                  })}

                <Route
                  path="*"
                  element={
                    <Navigate
                      to={{
                        pathname: urlFor('payMethodSelector'),
                        search: window.location.search,
                      }}
                      replace
                    />
                  }
                />
              </Routes>
            </>
          }
        />
      </Routes>
    </PaymentInitialization>
  );
}
